module.exports = __webpack_public_path__ + "static/media/bg-header.cbe2f338.png";